// extracted by mini-css-extract-plugin
module.exports = {"card":"Comprometemos_card__3csve","gallery":"Comprometemos_gallery__qIfXa"};